export const DEFAULT_INTERVAL_DURATION = 60000;
export const DEFAULT_MAX_TICK_COUNT = 59;
